var _circle, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F619(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDD67",
    cx: 32,
    cy: 32,
    r: 30
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#664E27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.048 26.596c-2.719-4.711-5.921-6.743-8.679-6.257s-5.072 3.492-6.015 8.848c-.091.539 1.014 1.287 1.398.707 1.444-2.186 3.436-3.305 5.65-3.695 2.216-.391 4.47-.02 6.574 1.54.56.413 1.342-.668 1.072-1.143zM50.585 22.799c-2.719-4.711-5.921-6.743-8.679-6.257s-5.072 3.491-6.016 8.848c-.092.539 1.014 1.287 1.397.706 1.444-2.186 3.435-3.305 5.651-3.695 2.216-.391 4.468-.02 6.573 1.54.561.413 1.344-.668 1.074-1.142z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M45.587 45.434c1.273-1.887-2.314-2.602-2.819-5.463-.504-2.861 2.624-4.761.781-6.099-2.205-1.604-6.014.574-8.994-1.592.373 2.118 2.559 4.118 5.883 3.532 0 0-2.1 1.309-1.479 4.829C39.58 44.163 42 44.676 42 44.676c-3.324.586-4.693 3.212-4.32 5.331 2.06-3.056 6.383-2.312 7.907-4.573z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F619);
export default __webpack_public_path__ + "static/media/1f619.3e151676069c2b08cd87d08762042eb6.svg";
export { ForwardRef as ReactComponent };